import { ThemeProvider } from '@/context/ThemeContext';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import IndustriesSection from './components/IndustriesSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ProcessSection from './components/ProcessSection';
import CtaSection from './components/CtaSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <ThemeProvider>
      <main className="font-grotesk">
        <Navbar />
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <IndustriesSection />
        <CaseStudiesSection />
        <ProcessSection />
        <CtaSection />
        <ContactSection />
        <Footer />
      </main>
    </ThemeProvider>
  );
}
